import React from 'react';
import { useAppSelector } from '../../../store/hooks';
import { selectUser } from '../../../store/reducers';

export function Dashboard(): React.JSX.Element {
  const user = useAppSelector(selectUser);

  return (
    <div className={'height-100'}>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <h1>Willkommen {user?.firstname}!!</h1>
      </div>
    </div>
  );
}
